import React from "react";
import "./Offer.css";
import SwiperCore, { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import groupsIcon from "./assets/svg/groups.svg";
import eventsIcon from "./assets/svg/events.svg";
import workshopsIcon from "./assets/svg/workshops.svg";
import arrowIcon from "./assets/svg/arrow.svg";
SwiperCore.use([Pagination]);
const offerItems = [
  {
    icon: groupsIcon,
    alt: "Támogató csoportjaink ikon",
    title: "Támogató csoportjaink",
    text: "Tagjaink részt vehetnek rendezvényeinken, chat csoportjainkban, illetve a hozzájuk leginkább illő, önkéntes egyesületi munkában (pl. programszervezés, média, tudományos kérdések, nemzetközi projektek, stb.)",
    link: null,
  },
  {
    icon: eventsIcon,
    alt: "Közösségi események ikon",
    title: "Közösségi események",
    text: "A BeszÉLJ! Egyesület elsődleges célja az érintettek közösségi támogatása (peer support). Ennek jegyében számos online és offline eseményt szervezünk.",
    link: "/events",
  },
  {
    icon: workshopsIcon,
    alt: "Workshopok ikon",
    title: "Workshopok, tréningek",
    text: "Egyesületünk fontos célja az érintettek személyes fejlődésének elősegítése. Ennek jegyében szervezünk különböző beszélgetéseket, műhelyeket és képzéseket.",
    link: null,
  },
];
const OfferCard = ({ item }) => (
  <div className="offer-card">
    <img src={item.icon} alt={item.alt} className="offer-icon" />
    <h3 className="heading-md">{item.title}</h3>
    <p className="body-md">{item.text}</p>
    {item.link && (
      <a href={item.link} className="learn-more-link">
        Tudj meg többet
        <img src={arrowIcon} alt="nyíl ikon" className="arrow-icon" />
      </a>
    )}
  </div>
);
const Offer = () => {
  return (
    <section className="offer-section">
      <div className="container">
        <h2 className="heading-md">Mit kínálunk</h2>
        <p className="offer-subtitle body-sm">
          Elsősorban a dadogó érintetteknek és családtagjaiknak kínálunk támogató
          közösséget, önkiteljesítési lehetőséget egy biztonságos térben,
          sorstársak között. Programjaink és kommunikációs felületeink egyaránt
          szólnak a tagságnak és az irántunk érdeklődőknek.
        </p>
        {/* Desktop / tablet grid */}
        <div className="offer-grid">
          {offerItems.map((item, index) => (
            <OfferCard item={item} key={index} />
          ))}
        </div>
        {/* Mobile swiper */}
        <div className="offer-swiper-wrap">
          <Swiper
            slidesPerView={1}
            spaceBetween={24}
            loop={true}
            loopedSlides={3}
            centeredSlides={true}
            grabCursor={true}
            allowTouchMove={true}
            touchRatio={1}
            threshold={5}
            pagination={{ clickable: true }}
          >
            {offerItems.map((item, index) => (
              <SwiperSlide key={index}>
                <OfferCard item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
export default Offer;